(function() {
    'use strict';
    angular
        .module('atheer.services')
        .factory('SecurityRole', SecurityRole);

    /* @ngInject */
    function SecurityRole($resource) {
        var resourceUrl = 'api/system/security-roles/:id';

        return $resource(resourceUrl, {
            id: '@id'
        }, {
            'query': {
                method: 'GET',
                isArray: true
            },
            'get': {
                method: 'GET',
                transformResponse: function(data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'update': {
                method: 'PUT'
            }
        });
    }
})();
